import { render } from "./Index.vue?vue&type=template&id=3d3f056f"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=3d3f056f&lang=css"
script.render = render

export default script